export abstract class Formatter<T> {
  abstract format(value: T): string;

  static get default() {
    return new DefaultFormatter();
  }
}

export class DefaultFormatter extends Formatter<unknown> {
  format(value: unknown): string {
    return String(value);
  }
}

export abstract class ParserFormatter<T> extends Formatter<T> {
  abstract get type(): string;

  abstract parse(valueStr: string): T;

  static get default() {
    return new DefaultParserFormatter();
  }
}

export class DefaultParserFormatter extends ParserFormatter<any> {
  format(value: any): string {
    return String(value);
  }

  parse(valueStr: string): any {
    return valueStr;
  }

  get type(): string {
    return '';
  }
}
